module.exports = __webpack_public_path__ + "static/media/gratian_mihailescu.7881b209.png";